import { routes } from "api/routes";
import auth from "services/auth";
import { getRequestUrl, getStatusCode, setAuthCookieForDev } from "utils/auth";
import { setOriginalUriToRestore } from "utils/auth/auth";
import { POST_LOGOUT_REDIRECT_URI } from "utils/constants/auth.constants";
import { HttpStatusCode } from "utils/constants/http.constants";

async function renewAccessToken() {
  try {
    await auth.renewAccessToken();
    await setAuthCookieForDev();
  } catch {
    window.location.href = POST_LOGOUT_REDIRECT_URI;
  }
}

export async function configureRequest<T>(
  requestExecutor: () => Promise<T>,
): Promise<T> {
  try {
    return await requestExecutor();
  } catch (error) {
    const shouldRenewAccessToken =
      error instanceof Error &&
      getStatusCode(error) === HttpStatusCode.Unauthorized &&
      getRequestUrl(error) !== routes.identity.auth.renewAccessToken();

    const isRefreshTokenExpired =
      error instanceof Error &&
      getRequestUrl(error) === routes.identity.auth.renewAccessToken();

    if (shouldRenewAccessToken) {
      await renewAccessToken();
    } else if (isRefreshTokenExpired) {
      setOriginalUriToRestore();
      window.location.href = POST_LOGOUT_REDIRECT_URI;
    }

    throw error;
  }
}
